/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/no-unnecessary-qualifier */
/* eslint-disable no-redeclare */
export enum InventoryStatus {
    Active = 'Active',
    TempOutOfStock = 'Temporarily out of stock',
    ComingSoon = 'Coming Soon',
    SoldOut = 'Sold Out',
    FreePromo = 'Free Promo',
    DoNotDisplay = 'Do Not Display',
    Inactive = 'Inactive',
    PreOrder = 'Pre Order'
}

export const SHOPPABLE_STATUSES = [
    InventoryStatus.Active,
    InventoryStatus.TempOutOfStock,
    InventoryStatus.FreePromo,
    InventoryStatus.PreOrder
];

export const DISPLAYABLE_STATUSES = [
    InventoryStatus.Active,
    InventoryStatus.TempOutOfStock,
    InventoryStatus.ComingSoon
];

export const NONDISPLAYABLE_STATUSES = [
    InventoryStatus.DoNotDisplay,
    InventoryStatus.Inactive,
    InventoryStatus.FreePromo,
    InventoryStatus.SoldOut
];

export namespace InventoryStatus {
    export function valueOf(stringValue: string): InventoryStatus {
        if (Object.values(InventoryStatus).includes(<InventoryStatus>stringValue)) {
            return <InventoryStatus>stringValue;
        }

        return InventoryStatus.Inactive;
    }
}

export const LEGACY_INVENTORY_STATUS: {
    [key: string]: string;
} = Object.freeze({
    '1': InventoryStatus.Active,
    '2': InventoryStatus.TempOutOfStock,
    '3': InventoryStatus.ComingSoon,
    '4': InventoryStatus.DoNotDisplay,
    '5': InventoryStatus.Inactive,
    '6': InventoryStatus.FreePromo,
    '7': InventoryStatus.SoldOut,
    '8': InventoryStatus.PreOrder
});
